import { createSlice } from "@reduxjs/toolkit";

export const userMgt_getResources = createSlice({
  name: "users management get resources",
  initialState: {
    value: {
      status: false,
      data: [] as {
        sn: number;
        id: number;
        resource_name: string;
        permissions: {
          all: boolean;
          read: boolean;
          create: boolean;
          update: boolean;
          delete: boolean;
        };
      }[],
    },
  },
  reducers: {
    user_mgt_updateResources: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    user_mgt_addResource: (state, action) => {
      const { id, resource_name, permissions } = action?.payload;
      state.value.data = [
        ...state.value.data,
        { id: id, resource_name, permissions, sn: state.value.data.length + 1 },
      ];
    },
    user_mgt_removeResource: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    user_mgt_replaceResources: (state, action) => {
      const { id, resource_name, permissions } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, {
        sn: currentArray[currentIndex]?.sn,
        id: id,
        resource_name,
        permissions,
      });
      state.value.data = currentArray;
    },
    user_mgt_clearResources: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  user_mgt_updateResources,
  user_mgt_addResource,
  user_mgt_removeResource,
  user_mgt_replaceResources,
  user_mgt_clearResources,
} = userMgt_getResources.actions;

export default userMgt_getResources.reducer;
